<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Valid Issued Visa Country Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="valid-issued-visa-countrywise" :export-date="range"
                                        :export-country="country"
                                        v-if="$oauth.checkIfHasPermission(['export valid-issued-visa-summary-report'])"/>
          <refresh-button :click-function="updateByCountry"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs6 class="d-flex align-center">
              <custom-date-range-picker @change="updateByCountry"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="country"
                  @change="updateByCountry"
              />
            </v-flex>

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <!--                        <v-data-table-->
            <!--                            :headers="headers"-->
            <!--                            :items="country_wise_data"-->
            <!--                            :loading="loading"-->
            <!--                            :options.sync="pagination"-->
            <!--                            :footer-props="footerProps"-->
            <!--                            class="elevation-0"-->
            <!--                            v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"-->
            <!--                            hide-default-footer>-->

            <!--                        </v-data-table>-->
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read issued-visa-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th colspan="2" style="border-bottom: 1px solid lightgray"></th>
                <!--                                <th colspan="4" class="text-center" style="border-right: 1px solid lightgray;border-bottom: 1px solid lightgray">Arrival</th>-->
                <th colspan="14" class="text-center" style="border-bottom: 1px solid lightgray">Visa Types</th>
              </tr>
              <tr>
                <th class="text-center">S.N</th>
                <th>Country</th>
                <th class="text-center">Tourist</th>
                <th class="text-center">Business</th>
                <th class="text-center">Transit</th>
                <th class="text-center">Marriage</th>
                <th class="text-center">Study</th>
                <th class="text-center">Residential</th>
                <th class="text-center">Nrn</th>
                <th class="text-center">Relation</th>
                <th class="text-center">Working</th>
                <th class="text-center">Diplomatic</th>
                <th class="text-center">Official</th>
                <th class="text-center">Dependent</th>
                <th class="text-center">Press</th>
                <th class="text-center">Reciprocity</th>
                <th class="text-center">Consular Gratis</th>
                <th class="text-center">SAARC Travel Endorsement</th>
                <th class="text-center">Non Tourist Visa (Others)</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="country_wise_data">
              <tr v-for="(item,i) in country_wise_data">
                <td>{{ i + 1 }}</td>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on">{{ item.country_code }}</span>
                    </template>
                    <span>{{ item.country }}</span>
                  </v-tooltip>
                </td>
                <td class="text-center">{{ item.tourist }}</td>
                <td class="text-center">{{ item.business }}</td>
                <td class="text-center">{{ item.transit }}</td>
                <td class="text-center">{{ item.marriage }}</td>
                <td class="text-center">{{ item.study }}</td>
                <td class="text-center">{{ item.residential }}</td>
                <td class="text-center">{{ item.nrn }}</td>
                <td class="text-center">{{ item.relation }}</td>
                <td class="text-center">{{ item.working }}</td>
                <td class="text-center">{{ item.diplomatic }}</td>
                <td class="text-center">{{ item.official }}</td>
                <td class="text-center">{{ item.dependent }}</td>
                <td class="text-center">{{ item.press }}</td>
                <td class="text-center">{{ item.reciprocity }}</td>
                <td class="text-center">{{ item.consular }}</td>
                <td class="text-center">{{ item.saarc }}</td>
                <td class="text-center">{{ item.nontourist }}</td>
                <td class="font-weight-bold text-center">{{ item.total }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_tourist }}</td>
                <td class="text-center">{{ total_business }}</td>
                <td class="text-center">{{ total_transit }}</td>
                <td class="text-center">{{ total_marriage }}</td>
                <td class="text-center">{{ total_study }}</td>
                <td class="text-center">{{ total_residential }}</td>
                <td class="text-center">{{ total_nrn }}</td>
                <td class="text-center">{{ total_relation }}</td>
                <td class="text-center">{{ total_working }}</td>
                <td class="text-center">{{ total_diplomatic }}</td>
                <td class="text-center">{{ total_official }}</td>
                <td class="text-center">{{ total_dependent }}</td>
                <td class="text-center">{{ total_press }}</td>
                <td class="text-center">{{ total_reciprocity }}</td>
                <td class="text-center">{{ total_consular_gratis }}</td>
                <td class="text-center">{{ total_saarc_travel_endorsement }}</td>
                <td class="text-center">{{ total_non_tourist_visa }}</td>
                <td class="text-center">{{ total_total_visa }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const ISSUED_VISA_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/valid-issued-visa-countrywise`;

export default {
  name: "ValidIssuedVisaCountryWise",
  data() {
    return {
      country_wise_data: [],
      range: {},
      country: [],
      total_tourist: 0,
      total_business: 0,
      total_transit: 0,
      total_marriage: 0,
      total_study: 0,
      total_residential: 0,
      total_nrn: 0,
      total_relation: 0,
      total_working: 0,
      total_diplomatic: 0,
      total_official: 0,
      total_dependent: 0,
      total_press: 0,
      total_reciprocity: 0,
      total_consular_gratis: 0,
      total_saarc_travel_endorsement: 0,
      total_non_tourist_visa: 0,
      total_total_visa: 0
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
    }),
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });

    },
    departedReport(item) {
    },
    updateByCountry() {
      let params = {};
      this.progressLinearLoading = true;
      if (Object.keys(this.range).length > 0)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;
      this.total_tourist = 0
      this.total_business = 0
      this.total_transit = 0
      this.total_marriage = 0
      this.total_study = 0
      this.total_residential = 0
      this.total_nrn = 0
      this.total_relation = 0
      this.total_working = 0
      this.total_diplomatic = 0
      this.total_official = 0
      this.total_dependent = 0
      this.total_press = 0
      this.total_reciprocity = 0
      this.total_consular_gratis = 0
      this.total_saarc_travel_endorsement = 0
      this.total_non_tourist_visa = 0
      this.total_total_visa = 0
      Http.get(ISSUED_VISA_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.country_wise_data = res.data.data;
            this.country_wise_data.forEach(item => {
              this.total_tourist += item.tourist
              this.total_business += item.business
              this.total_transit += item.transit
              this.total_marriage += item.marriage
              this.total_study += item.study
              this.total_residential += item.residential
              this.total_nrn += item.nrn
              this.total_relation += item.relation
              this.total_working += item.working
              this.total_diplomatic += item.diplomatic
              this.total_official += item.official
              this.total_dependent += item.dependent
              this.total_press += item.press
              this.total_reciprocity += item.reciprocity
              this.total_consular_gratis += item.consular
              this.total_saarc_travel_endorsement += item.saarc
              this.total_non_tourist_visa += item.nontourist
            })
            this.total_total_visa = this.total_tourist + this.total_business + this.total_transit + this.total_marriage + this.total_study + this.total_residential + this.total_nrn + this.total_working + this.total_relation + this.total_diplomatic + this.total_official + this.total_dependent + this.total_press + this.total_reciprocity + this.total_consular_gratis + this.total_saarc_travel_endorsement + this.total_non_tourist_visa;
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    if (this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }
    this.progressLinearLoading = true;
    Http.get(ISSUED_VISA_SUMMARY_REPORT_URL)
        .then((res) => {
          this.country_wise_data = res.data.data;
          this.country_wise_data.forEach(item => {
            this.total_tourist += item.tourist
            this.total_business += item.business
            this.total_transit += item.transit
            this.total_marriage += item.marriage
            this.total_study += item.study
            this.total_residential += item.residential
            this.total_nrn += item.nrn
            this.total_relation += item.relation
            this.total_working += item.working
            this.total_diplomatic += item.diplomatic
            this.total_official += item.official
            this.total_dependent += item.dependent
            this.total_press += item.press
            this.total_reciprocity += item.reciprocity
            this.total_consular_gratis += item.consular
            this.total_saarc_travel_endorsement += item.saarc
            this.total_non_tourist_visa += item.nontourist
          })
          this.total_total_visa = this.total_tourist + this.total_business + this.total_transit + this.total_marriage + this.total_study + this.total_residential + this.total_nrn + this.total_working + this.total_relation + this.total_diplomatic + this.total_official + this.total_dependent + this.total_press + this.total_reciprocity + this.total_consular_gratis + this.total_saarc_travel_endorsement + this.total_non_tourist_visa;
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
    // this.$store.commit('CommonList/setModel', 'summary-report/arrival-departure-countrywise');
  }
}
</script>
